import ChatActionPanel from './ChatActionPanel'
import { getLocalizedProductText } from './utils/productHelpers'

const ProductFlowActions = ({
  productFlowStep,
  selectedProduct,
  typing,
  productRoutineLoading,
  productUrl,
  onViewRoutine,
  onBuy,
  onDecline,
  onContinueExploring,
  onLogOut,
  translations = {},
  language = 'EN',
}) => {
  if (typing || !productFlowStep) return null

  if (productFlowStep === 'routine_prompt' && selectedProduct) {
    return (
      <ChatActionPanel>
        <button
          type='button'
          className='upload-send-btn'
          onClick={onViewRoutine}
          disabled={productRoutineLoading}
          style={{ minWidth: '220px' }}
        >
          {productRoutineLoading
            ? getLocalizedProductText({
                translations,
                language,
                keyPath: 'productFlow.loadingRoutine',
                fallback: 'Loading routine...',
              })
            : getLocalizedProductText({
                translations,
                language,
                keyPath: 'productFlow.viewProductRoutine',
                fallback: 'View product routine',
              })}
        </button>
      </ChatActionPanel>
    )
  }

  if (productFlowStep === 'buy_prompt' && selectedProduct) {
    return (
      <ChatActionPanel gap='10px'>
        <a
          href={productUrl}
          target='_blank'
          rel='noopener noreferrer'
          className='upload-send-btn'
          onClick={onBuy}
          style={{
            textDecoration: 'none',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {getLocalizedProductText({
            translations,
            language,
            keyPath: 'productFlow.buyYes',
            fallback: 'Yes, buy it',
          })}
        </a>

        <button type='button' className='upload-send-btn' onClick={onDecline}>
          {getLocalizedProductText({
            translations,
            language,
            keyPath: 'productFlow.buyNo',
            fallback: 'No',
          })}
        </button>
      </ChatActionPanel>
    )
  }

  if (productFlowStep === 'next_action') {
    return (
      <ChatActionPanel gap='10px'>
        <button
          type='button'
          className='upload-send-btn'
          onClick={onContinueExploring}
        >
          {getLocalizedProductText({
            translations,
            language,
            keyPath: 'productFlow.continueExploringAction',
            fallback: 'Continue exploring',
          })}
        </button>

        <button type='button' className='upload-send-btn' onClick={onLogOut}>
          {getLocalizedProductText({
            translations,
            language,
            keyPath: 'productFlow.logOutAction',
            fallback: 'Log out',
          })}
        </button>
      </ChatActionPanel>
    )
  }

  return null
}

export default ProductFlowActions
